export default __webpack_public_path__ + "static/media/linkedin.df776527.svg";